/** A reply belongs to the view that initiated it, not whichever view is open later. */
export class WorkspaceSession {
  private revision = 0;
  private page = "";
  private projectId: string | null = null;

  enter(page: string, projectId: string | null = null) {
    if (this.page !== page || this.projectId !== projectId) this.revision++;
    this.page = page;
    this.projectId = projectId;
  }

  invalidate() {
    this.revision++;
  }

  capture() {
    const revision = this.revision;
    return {
      projectId: this.projectId,
      isCurrent: () => this.revision === revision,
    };
  }
}
